import React from 'react';
import { Button, Dialog, DialogContent, Box, IconButton, Typography } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { closeRoleSelectAsync, getUserInfo } from 'store/slices/userInfoSlice';
import Spin from '../../atoms/Spin/Spin';

const RoleSelect = ({ isLogin }: { isLogin: boolean }) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const { roles, selectRoleOpen: open, roleList, roleLoading } = useSelector(getUserInfo);
    const roleDictionary = roleList?.filter((r) => roles.includes(r.code) && r.code !== 'COURIER');

    const handleClose = (selected: boolean, role: any) => {
        dispatch(
            closeRoleSelectAsync(
                selected,
                role.code,
                () => {
                    history.push('/cabinet');
                },
                isLogin
            )
        );
    };

    return (
        <Dialog
            open={open !== undefined && open}
            fullWidth={true}
            onClose={() => handleClose(false, '')}
        >
            <MuiDialogTitle disableTypography className={classes.root}>
                <Typography variant="h6">Выберите роль</Typography>
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={() => handleClose(false, '')}
                >
                    <CloseIcon />
                </IconButton>
            </MuiDialogTitle>
            <DialogContent className={classes.dialogContent}>
                {roleLoading && <Spin />}
                <Box
                    position="relative"
                    display="flex"
                    minHeight="400px"
                    flexDirection="column"
                    minWidth="200px"
                    width="300px"
                >
                    {roleDictionary?.map((role) => (
                        <Button
                            className={classes.roleButton}
                            key={role.code}
                            onClick={() => handleClose(true, role)}
                            variant="contained"
                            color="primary"
                        >
                            {role.description}
                        </Button>
                    ))}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    dialogContent: {
        display: 'flex',
        justifyContent: 'center',
    },
    roleButton: {
        marginTop: theme.spacing(1),
    },
}));

export default RoleSelect;
